module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "md4": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "align-center": "",
      "fill-height": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.eventUid) ? _c('v-card', {
    staticClass: "elevation-5"
  }, [_c('v-card-text', [_c('div', {
    staticClass: "body-1 card-title-text"
  }, [_vm._v("\n            Введите новый пароль для Вашей учетной записи и нажмите на кнопку \"Сменить пароль\"\n          ")]), _vm._v(" "), _c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formValid),
      callback: function($$v) {
        _vm.formValid = $$v
      },
      expression: "formValid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "autocomplete": "new-password",
      "prepend-icon": "mdi-lock",
      "name": "password",
      "label": "Новый пароль",
      "type": "password",
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.newPassword),
      callback: function($$v) {
        _vm.newPassword = $$v
      },
      expression: "newPassword"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": "",
      "disabled": !_vm.formValid
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changePassword()
      }
    }
  }, [_vm._v("Сменить пароль")])], 1)], 1) : _c('v-card', {
    staticClass: "elevation-5"
  }, [_c('v-card-text', [(_vm.sent) ? _c('div', {
    staticClass: "body-1 card-title-text"
  }, [_vm._v("Письмо со ссылкой для смены пароля отправлено на адрес "), _c('b', [_vm._v(_vm._s(_vm.sentEmail))]), _vm._v(". Для продолжения проверьте Ваш почтовый ящик и перейдите по ссылке, указанной в письме."), _c('br'), _vm._v("Для повторной отправки введите Ваш электронный адрес и нажмите \"Отправить\" снова.\n          ")]) : _c('div', {
    staticClass: "body-1 card-title-text"
  }, [_vm._v("Для продолжения необходимо ввести адрес электронной почты, указанный при регистрации. Нажмите \"Отправить\" чтобы отправить письмо с ссылкой для смены пароля")]), _vm._v(" "), _c('v-form', {
    ref: "form",
    attrs: {
      "id": "form"
    },
    model: {
      value: (_vm.formValid),
      callback: function($$v) {
        _vm.formValid = $$v
      },
      expression: "formValid"
    }
  }, [_c('v-text-field', {
    ref: "email",
    attrs: {
      "prepend-icon": "mdi-email-outline",
      "name": "mail",
      "label": "E-mail",
      "type": "email",
      "rules": [_vm.rules.required, _vm.rules.email]
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": "",
      "disabled": _vm.sentButtonDisabled
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.sendForgotPasswordMessage()
      }
    }
  }, [_vm._v("Отправить\n            "), (_vm.sentTimeout) ? _c('span', [_vm._v(" (" + _vm._s(_vm.sentTimeout) + ")")]) : _vm._e()])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "margin-top": "14px"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "6px"
    }
  }, [_vm._v("Другая учетная запись?")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$router.push('/login')
      }
    }
  }, [_vm._v("Войти")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54bdf6be","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./webapp/components/ForgotPassword.vue
// module id = 482
// module chunks = 0